// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3DbIf","containerItemsCenter":"Skeleton_containerItemsCenter__agVDO"};